import { differenceInDays } from 'date-fns';
import * as Yup from 'yup';

export const MissionUpdateSchema = Yup.object().shape({
  liveEvent: Yup.boolean(),
  eventStart: Yup.date().required(),
  dueDate: Yup.date(),
});
